$(document).ready(function () {
  $('.banner-list').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1
  });

  $('.category-list').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      } 
    ]
  });

  $('.product-slider').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
     {
        breakpoint: 1440,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1320,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      } 
    ]
  });
  $('.reviews-list').slick({
    dots: false,
    arrows: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      } 
    ]
  });
  $(".slider-for-pdp").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".slider-nav-pdp"
  });
  $(".slider-nav-pdp").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    vertical: false,
    asNavFor: ".slider-for-pdp",
    dots: false,
    focusOnSelect: true,
    verticalSwiping: true,
    responsive: [
          {
        breakpoint: 1200,
        settings: {
          vertical: false,
           slidesToShow: 2,
        }
      },
      {
        breakpoint: 992,
        settings: {
          vertical: false,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          vertical: false,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 580,
        settings: {
          vertical: false,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 380,
        settings: {
          vertical: false,
          slidesToShow: 1
        }
      }
    ]
  });
  $(".header__inline-menu ul.list-menu.list-menu--inline li").hover(function(){
    $(this).find("header-menu").find("details").attr("open", "open");
    $(this).find("header-menu").find(".header__submenu").find("details").removeAttr("open");
  }, function(){
    $(this).find("header-menu").find("details").removeAttr("open");
  });
  $('[data-fancybox="gallery"]').fancybox({
    buttons: [
      "slideShow",
      "thumbs",
      "zoom",
      "fullScreen",
      "share",
      "close"
    ],
    loop: false,
    protect: true
  });
  
});